"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.required = void 0;
const DEFAULT_MESSAGE = 'This field is required';
/**
 * Validates that the field has a truthy value.
 * The only exception is the number 0.
 *
 * @param rule
 * @returns {(opts:any)=>boolean|string}
 */
const required = (rule) => {
    if (typeof rule !== 'string' &&
        rule !== undefined &&
        rule.required === false) {
        return () => true;
    }
    return (opts) => {
        return opts.value || opts.value === 0 // 0 is the only allowed falsy value.
            ? true
            : (typeof rule === 'string' ? rule : rule && rule.msg) || DEFAULT_MESSAGE;
    };
};
exports.required = required;
//# sourceMappingURL=requiredValidator.js.map